import script from "./killerStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./killerStudy.vue?vue&type=script&setup=true&lang=js"

import "./killerStudy.vue?vue&type=style&index=0&id=46bc41d6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bc41d6"]])

export default __exports__